import { gql } from '@provision/graphql-client';
import { getStoredAttributeHooks } from './stored-attributes';

const CONVERSATION_CUSTOM_ATTRIBUTES_FRAGMENT = gql`
  fragment ConversationCustomAttributesFields on Conversation {
    id
    conversationId
    customAttributes
  }
`;

const GET_CONVERSATION_CUSTOM_ATTRIBUTES = gql`
  query GetConversationCustomAttributes($params: QueryParamsWithSearch)
  @entity(name: "Conversation") {
    getConversation(queryParams: $params) {
      records {
        id
        conversationId
        customAttributes
      }
    }
  }
`;

const UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES_MUTATION = gql`
  mutation UpdateConversationCustomAttributes(
    $conditions: [ConditionInput]
    $data: ConversationDataInput
  ) {
    updateConversation(conditions: $conditions, data: $data) {
      ...ConversationCustomAttributesFields
    }
  }
  ${CONVERSATION_CUSTOM_ATTRIBUTES_FRAGMENT}
`;

export const conversationCustomAttributesConfig = getStoredAttributeHooks({
  typename: 'Conversation',
  idAttribute: 'conversationId',
  fragment: CONVERSATION_CUSTOM_ATTRIBUTES_FRAGMENT,
  fragmentName: 'ConversationCustomAttributesFields',
  query: GET_CONVERSATION_CUSTOM_ATTRIBUTES,
  queryRootField: 'getConversation',
  mutation: UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES_MUTATION,
});
